import React from 'react';

export const Opinion: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg viewBox="0 0 48 48" width={width || '1em'} height={height || '1em'}>
        <path d="M37 47H11a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4h19c.32 0 .593.161.776.395l9.829 9.829A.981.981 0 0 1 41 12v31a4 4 0 0 1-4 4zM31 4.381V11h6.619L31 4.381zM39 13h-9a1 1 0 0 1-1-1V3H11a2 2 0 0 0-2 2v38a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2V13zm-6 26H15a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0-8H15a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0-8H15a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2z" stroke={color || 'currentColor'} fill={color || 'currentColor'} />
    </svg>
);
